import * as moment from "moment";
import * as immunisationReviewActions from "@teamprevent/common/questionnaires/components/immunisationReview/actionTypes";

import * as clinicalNotesActions from "../../clinicalNotes/actionTypes";
import * as bloodTestActions from "../../bloodTest/actionTypes";
import * as vaccinationActions from "../../vaccinationConsultation/actionTypes";
import * as bbvActions from "../../bbvConsultation/actionTypes";
import { ClinicalNotesAction } from "../../clinicalNotes/actions";
import { BloodTestAction } from "../../bloodTest/actions";
import { VaccinationConsultationAction } from "../../vaccinationConsultation/actions";
import { BbvConsultationAction } from "../../bbvConsultation/actions";
import * as referralReportActions from "../../referralReport/actionTypes";
import * as bookAppointmentsActions from "../../bookAppointments/actionTypes";
import * as bbvReportActions from "../../bbvReport/actionTypes";
import * as immunisationOhCaseActions from "../../immunisationOhCase/actionTypes";
import * as videoMeetingsActions from "../../videoMeeting/actionTypes";
import { ReferralReportAction } from "../../referralReport/actions";
import { BookAppointmentAction } from "../../bookAppointments/actions";
import { SubmitBbvReportSuccess } from "../../bbvReport/actions";
import { ImmunisationReviewAction } from "../../immunisationReview/actions";
import { ImmunisationCaseAction } from "../../immunisationOhCase/actions";
import { VideoMeetingsAction } from "../../videoMeeting/actions";
import * as mhpTreatmentActions from "../../mentalHealthPractitionerTreatment/actionTypes";
import { MHPTreatmentAction } from "../../mentalHealthPractitionerTreatment/actions";

import { ApplicationState } from "../../applicationState";

import { PpqReportAction } from "../../ppqReport/actions";

import * as ppqActions from "../../ppqReport/actionTypes";

import { OhCaseAction } from "./actions";
import * as actions from "./actiontypes";
import { detailUpdated, ohCase } from "./reducerOhCase";

export type ReducerAction =
    OhCaseAction | ClinicalNotesAction | ReferralReportAction | BookAppointmentAction | BbvConsultationAction
    | SubmitBbvReportSuccess | ImmunisationReviewAction | BloodTestAction | VaccinationConsultationAction | ImmunisationCaseAction
    | VideoMeetingsAction | MHPTreatmentAction | PpqReportAction;

export function ohCases(state: ApplicationState["ohCases"] = [], action: ReducerAction): ApplicationState["ohCases"] {
    switch (action.type) {
        case actions.LOAD_OHCASES_SUCCESS:
            return action.payload.map(c => ({ ...c, listUpdated: moment() }));
        case actions.LOAD_DETAILED_OHCASES_SUCCESS:
            return action.payload.map(c => ({ ...c, listUpdated: moment(), detailUpdated: moment() }));
        case actions.LOAD_OHCASE_DETAIL_SUCCESS:
        case referralReportActions.SUBMIT_REFERRAL_REPORT_SUCCESS:
        case referralReportActions.SENDTOEMPLOYEE_REFERRAL_REPORT_SUCCESS:
        case referralReportActions.APPROVE_REFERRAL_REPORT_SUCCESS:
        case mhpTreatmentActions.SUBMIT_MHP_TREATMENT_REPORT_SUCCESS:
        case ppqActions.SENDTOEMPLOYEE_PPQ_CERTIFICATE_SUCCESS:
        case ppqActions.APPROVE_PPQ_CERTIFICATE_SUCCESS:
            if (!state.some(c => c.id === action.payload.id)) {
                return [...state, ohCase({ id: action.payload.id, tasks: [], medicalTypes: [] }, action)];
            }
            return state.map(c => ohCase(c, action));
        case actions.UPDATE_ASSOCIATED_MANAGERS_SUCCESS:
        case actions.UPDATE_ASSOCIATED_HR_USERS_SUCCESS:
        case actions.UPDATE_PURCHASE_ORDER_NUMBER_SUCCESS:
        case actions.SET_OHCASE_CONFIDENTIALITY_SUCCESS:
        case clinicalNotesActions.SUBMIT_CLINICAL_NOTES_SUCCESS:
        case clinicalNotesActions.SUBMIT_DID_NOT_ATTEND_SUCCESS:
        case bloodTestActions.SUBMIT_BLOOD_TEST_CONSULTATION_SUCCESS:
        case vaccinationActions.SUBMIT_VACCINATION_CONSULTATION_SUCCESS:
        case bbvActions.SUBMIT_BBV_CONSULTATION_SUCCESS:
        case bbvReportActions.SUBMIT_BBV_REPORT_SUCCESS:
        case bookAppointmentsActions.BOOK_AD_HOC_APPOINTMENT_SUCCESS:
        case bookAppointmentsActions.BOOK_INTO_CLINIC_SUCCESS:
        case bookAppointmentsActions.REBOOK_APPOINTMENT_SUCCESS:
        case actions.CREATE_OHCASE_DOCUMENT_SUCCESS:
        case actions.LOAD_OHCASE_DOCUMENTS_SUCCESS:
        case actions.DELETE_OHCASE_DOCUMENT_SUCCESS:
        case immunisationReviewActions.SUBMIT_IMMUNISATION_REVIEW_SUCCESS:
        case actions.ACTION_TASK_SUCCESS:
        case actions.DELETE_TASK_SUCCESS:
        case actions.EDIT_TASK_COMPLETION_DATA_SUCCESS:
        case videoMeetingsActions.CREATE_TEAMS_MEETING_SUCCESS:
        case videoMeetingsActions.UNABLE_TO_BOOK_VIDEO_APPOINTMENT_SUCCESS:
        case videoMeetingsActions.COMPLETE_CREATE_VIDEO_CONSULTATION_SUCCESS:
        case referralReportActions.REQUEST_CHANGES_REFERRAL_REPORT_SUCCESS:
        case referralReportActions.REQUEST_REFERRAL_REPORT_EDIT_SUCCESS:
        case referralReportActions.REJECT_REFERRAL_REPORT_SUCCESS:
        case mhpTreatmentActions.REQUEST_CHANGES_MHP_TREATMENT_REPORT_SUCCESS:
        case mhpTreatmentActions.REJECT_MHP_TREATMENT_REPORT_SUCCESS:
        case ppqActions.REQUEST_CHANGES_PPQ_CERTIFICATE_SUCCESS:
        case ppqActions.REJECT_PPQ_CERTIFICATE_SUCCESS:
            if (!state.some(c => c.id === action.payload.ohCaseId)) {
                return [...state, ohCase({ id: action.payload.ohCaseId, tasks: [], medicalTypes: [] }, action)];
            }
            return state.map(c => ohCase(c, action));
        case actions.CREATE_OHCASE_SUCCESS:
        case actions.CREATE_BBV_CASE_SUCCESS:
        case actions.CREATE_HEALTH_SURVEILLANCE_CASE_SUCCESS:
            return [...state, detailUpdated(action.payload)];
        case actions.CREATE_IMMUNISATION_CASE_SUCCESS:
            return [...state.map(c => ohCase(c, action)), detailUpdated(action.payload)];
        case actions.CREATE_TASK_SUCCESS:
        case actions.CREATE_TASKS_SUCCESS:
        case actions.CANCEL_TASK_SUCCESS:
        case immunisationOhCaseActions.MARK_OH_CASE_IMMUNISATION_CLEAR_SUCCESS:
            return state.map(c => ohCase(c, action));
        default:
            return state;
    }
}
